import { sanitizeCommaDecimal } from './bigJSHelper'

/**
 * Takes a currency string and strips all non-digits and one decimal. This expects
 * a properly formatted currency with a single decimal and potential '-'. It will
 * not replace extra decimals or improperly formatted amounts.
 *
 */
export const getAmountFromLocaleCurrency = (currency: string): string => {
  const sanitizedValue = sanitizeCommaDecimal(currency)

  return sanitizedValue.replace(/[^0-9.-]+/g, '')
}
